var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"logo":_vm.logo,"logoLink":_vm.logoLink}}),_c('main',{class:`wrapper ${_vm.mainClass}`},[_vm._t("default")],2),_c('footer-layout',{attrs:{"footer-area-color":_vm.footerAreaColor,"footerText":_vm.footerText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }